module.exports = __webpack_public_path__ + "static/img/logo.679d7516.png";